import { Skeleton } from "@components/Skeleton/Skeleton";

export const BudgetSkeleton: React.FC = () => {
  return (
    <div className="grid grid-cols-1 gap-6 lg:grid-cols-2 xl:grid-cols-3">
      <Skeleton className="col-span-2 h-44 rounded-2xl" />
      <Skeleton className="order-3 col-span-2 min-h-96 rounded-2xl xl:order-none xl:col-span-1 xl:row-span-2" />
      <Skeleton className="col-span-2 h-80 self-stretch rounded-2xl" />
      <Skeleton className="order-4 col-span-2 h-[39rem] rounded-2xl xl:col-span-3" />
      <Skeleton className="order-5 col-span-2 h-[39rem] rounded-2xl xl:col-span-3" />
      <div className="order-6 col-span-2 grid grid-cols-1 gap-6 xl:col-span-3 xl:grid-cols-2">
        <Skeleton className="h-96 rounded-2xl" />
        <Skeleton className="h-96 rounded-2xl" />
      </div>
    </div>
  );
};
